import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Feature flag for the student-facing Interactive section (Cases + Pathways).
 * Reads the `interactive_section_enabled` key from `study_settings`.
 * Absent or anything other than 'true' is treated as disabled (fail closed),
 * so the Interactive tab stays hidden from students until a super admin turns it on.
 * Admins (teacher/admin/module/topic/platform/super) are never gated by this flag —
 * they always see the Interactive section so they can build and test content.
 */
export function useInteractiveSectionEnabled() {
  return useQuery({
    queryKey: ['study-settings', 'interactive_section_enabled'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('study_settings')
        .select('value')
        .eq('key', 'interactive_section_enabled')
        .maybeSingle();
      if (error) throw error;
      return data?.value === 'true';
    },
    staleTime: 60_000,
  });
}
